import _get from "lodash/get";
import React, { useEffect, useState } from 'react';
const defaultProps = {
  isBold: false,
  isUnderline: false,
  isItalic: false,
  isStrikeThrough: false
};
const DynamicField = _ref => {
  let {
    apiResponseAttributePath,
    isBold,
    isUnderline,
    isItalic,
    isStrikeThrough,
    apiResponse
  } = _ref;
  const {
    0: dynamicFieldValue,
    1: setDynamicFieldValue
  } = useState('');
  const getDynamicValue = async () => {
    const dynamicValue = _get(apiResponse, apiResponseAttributePath);
    setDynamicFieldValue(dynamicValue);
  };
  useEffect(() => {
    getDynamicValue();
  }, [apiResponse]);
  let dynamicComponent = dynamicFieldValue;
  dynamicComponent = isStrikeThrough ? /*#__PURE__*/React.createElement("s", null, dynamicComponent) : dynamicComponent;
  dynamicComponent = isBold ? /*#__PURE__*/React.createElement("strong", null, dynamicComponent) : dynamicComponent;
  dynamicComponent = isItalic ? /*#__PURE__*/React.createElement("em", null, dynamicComponent) : dynamicComponent;
  dynamicComponent = isUnderline ? /*#__PURE__*/React.createElement("u", null, dynamicComponent) : dynamicComponent;
  return /*#__PURE__*/React.createElement(React.Fragment, null, dynamicComponent);
};
DynamicField.defaultProps = defaultProps;
export { DynamicField };